// Välihömpsy: reveal-on-scroll for elements marked with data-vh-reveal.
(() => {
  const root = document.documentElement;
  // The inline fail-safe in theme.liquid removes vh-js if this script is slow.
  // Content is already visible then, so do not hide it again.
  if (!root.classList.contains('vh-js')) return;
  root.classList.add('vh-motion-ready');

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealAll = (scope) =>
    scope.querySelectorAll('[data-vh-reveal]').forEach((el) => el.classList.add('is-revealed'));

  if (reduce || !('IntersectionObserver' in window)) {
    revealAll(document);
    document.addEventListener('DOMContentLoaded', () => revealAll(document));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const observe = (scope) =>
    scope.querySelectorAll('[data-vh-reveal]:not(.is-revealed)').forEach((el) => observer.observe(el));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(document));
  } else {
    observe(document);
  }
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => revealAll(event.target));
})();
